import React from 'react';
import { ArrowRight, ShieldCheck, Lock, Clock } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing-section" className="py-20 bg-brand-bg px-4" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        {/* Proof / Believability */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-teal/20 mb-12 text-center" data-id="element-128">
          <Clock className="w-10 h-10 text-brand-teal mx-auto mb-4" data-id="element-129" />
          <p className="text-xl text-brand-dark leading-relaxed font-medium italic" data-id="element-130">
            "En las primeras 24 horas, la mayoría de los usuarios reportan una
            mayor frecuencia urinaria —la señal inconfundible de que el cuerpo
            está soltando líquidos—. Para la mañana del segundo día, es común
            notar que los anillos entran con facilidad, los zapatos ya no
            aprietan y la presión en la cintura del pantalón ha cedido
            notablemente."
          </p>
        </div>

        {/* Pricing Box */}
        <div className="bg-brand-dark text-white rounded-3xl overflow-hidden shadow-2xl" data-id="element-131">
          <div className="bg-brand-teal p-4 text-center" data-id="element-132">
            <p className="font-bold tracking-wider text-sm" data-id="element-133">
              OFERTA ESPECIAL DE LANZAMIENTO
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-134">
            <h2 className="font-serif text-3xl md:text-4xl mb-4" data-id="element-135">
              Protocolo Anti-Inflamación 48h
            </h2>
            <p className="text-gray-300 text-lg mb-8 max-w-xl mx-auto" data-id="element-136">
              Hoy puedes obtener el acceso inmediato por menos de lo que cuesta
              un suplemento que no te funcionó. Sin suscripciones, sin pagos
              mensuales.
            </p>

            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-137">
              <span className="text-gray-400 line-through text-2xl" data-id="element-138">
                $29 USD
              </span>
              <span className="text-5xl md:text-6xl font-bold text-brand-amber" data-id="element-139">
                $9.99 USD
              </span>
            </div>

            <a href="https://vitalizateahora.com/cart/51852231606503:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto flex items-center justify-center gap-3 bg-brand-amber hover:bg-brand-amberHover text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] transition-all transform hover:-translate-y-1 mx-auto mb-6 no-underline" data-id="element-140">
              Desinflámate ahora
              <ArrowRight className="w-6 h-6" data-id="element-141" />
            </a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-400" data-id="element-142">
              <span className="flex items-center gap-1" data-id="element-143">
                <Lock className="w-4 h-4" data-id="element-144" /> Pago 100% Seguro
              </span>
              <span className="hidden md:inline" data-id="element-145">•</span>
              <span className="flex items-center gap-1" data-id="element-146">
                <ShieldCheck className="w-4 h-4" data-id="element-147" /> Acceso instantáneo en PDF
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}